<template>
    <div>
        <!-- Aval -->
        <v-row>
            <v-col cols="12">
                <v-alert outlined type="info" color="warning" class="alert-info">
                    <p class="a-title">En este tipo de producto, es totalmente necesario aportar un aval para poder tramitar la operación.</p>
                    <div>
                       <v-checkbox
                            v-model="preScoring.Vivienda.avalista"
                            color="var(--helloteca-main)"
                            :false-value=0
                            :true-value=1
                        >
                            <template v-slot:label>
                                <div style="font-size: 1.1rem; font-weight:700">Sí, tengo aval</div>
                            </template>
                        </v-checkbox>

                    </div>
                </v-alert>
            </v-col>
        </v-row>  
        <v-row id="avalista_block" v-if="preScoring.Vivienda.avalista === 1" >
            <v-col cols="12">
                <p>Un aval es una propiedad sin cargas (propia o familiar) que pueda aportarse como garantía de la hipoteca, para poder financiar un % mayor.</p>
            </v-col>
            <v-col cols=12 sm=6>
                <v-select 
                    label="¿Quien te avalará? *"
                    outlined
                    v-model="preScoring.Avales.avalista_tipo"
                    :items="guarantors"
                    :rules="[...ruleRequired]"
                    item-text="text"
                    item-value="value"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6>
                <v-select 
                    label="¿Tiene hipoteca la vivienda? *"
                    outlined
                    v-model="preScoring.Avales.avalista_hipoteca"
                    :items="[{text:'Si', value:1},{text:'No', value:0}]"
                    :rules="[...ruleRequiredWith0]"
                    item-text="text"
                    item-value="value"
                    dense
                />
            </v-col>
            <v-col cols=12 sm=6>
                <v-currency-field
                    label="¿Qué valor tiene la vivienda de tus avalistas? *"
                    outlined
                    v-model="preScoring.Avales.avalista_valor_vivienda"
                    :rules="[...ruleMin10000,...ruleMax100M]"
                    append-icon="mdi-currency-eur"
                    hint="Introduce aquí, el valor aproximado de mercado de la vivienda"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
            <v-col cols=12 sm=6 v-if="preScoring.Avales.avalista_hipoteca === 1">
                <v-currency-field
                    label="Capital pendiente de la hipoteca *"
                    outlined
                    v-model="preScoring.Avales.avalista_hipoteca_pendiente"
                    :rules="[ruleRequired,...ruleMax100M]"
                    :min="0"
                    append-icon="mdi-currency-eur"
                    hint="Si no lo conoces exactamente no importa, introduce un valor aproximado"
                    persistent-hint
                    dense
                ></v-currency-field>
            </v-col>
        </v-row> 
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import rulesMixin from '../mixins/rulesMixin';
    import goTo from 'vuetify/es5/services/goto'

    export default {
        mixins: [rulesMixin],
        methods: {
            
        },
        computed: {
            ...mapState([
                'preScoring',
                'guarantors',
                'propertyStatuses',
                'propertyNew'
            ]),
        },
        mounted(){
            console.log("preScoring",this.preScoring);
        },
        watch:{
            'preScoring.Vivienda.avalista': function(newVal,oldVal){
                if(newVal == 1){
                    setTimeout(() => {
                        const el = document.querySelector("#avalista_block");
                        goTo(el, {offset:20});
                    }, 200);
                }
            }
        }
    }
</script>

<style lang="scss">
    .alert-info{
        .v-alert__icon{
            margin-top: 0px;
            font-size: 1.6rem !important;
        }
        .a-title{
            font-size: 1.1rem;
            margin-bottom: 0;
            padding-left: 3px;
        }
    }
</style>